"use strict";

import angular from "angular";

const MIN_FILMS = 1;
const MAX_FILMS = 9999;

export class RepeatFilmDialogModel {
  constructor(data) {
    this.ssn = data.ssn;
    this.sDate = data.sDate;
    this.projections = data.projections || [];
    this.reasons = data.reasons || [];
    this.records = (data.records || []).map((r) => ({
      Id: r.Id || "",
      Projection: r.Projection || "",
      Reason: r.Reason || "",
      Films: r.Films || MIN_FILMS,
    }));

    this.editing = false;
    this.editIndex = -1;
    this.current = null;
    this.submitted = false;

    this.saved = false;
    this.cancelled = false;

    this.modalService = null;
    this.scope = null;
    this.modalInstance = null;
  }

  init(modal, scope, modalService) {
    this.modalInstance = modal;
    this.scope = scope;
    this.modalService = modalService;
  }

  add() {
    this.current = { Id: "", Projection: "", Reason: "", Films: MIN_FILMS };
    this.editIndex = -1;
    this.submitted = false;
    this.editing = true;
  }

  modify(index) {
    this.current = angular.copy(this.records[index]);
    this.editIndex = index;
    this.submitted = false;
    this.editing = true;
  }

  delete(index) {
    this.records.splice(index, 1);
  }

  saveCurrent() {
    this.submitted = true;

    if (!this.current.Projection || !this.current.Reason) {
      this.modalService.showAlert(
        "Repeat Projection and Repeat Reason are required."
      );
      return;
    }

    this.current.Films = this.normalizeFilms(this.current.Films);

    if (this.editIndex >= 0) {
      this.records[this.editIndex] = this.current;
    } else {
      this.records.push(this.current);
    }

    this.editing = false;
    this.current = null;
    this.editIndex = -1;
    this.submitted = false;
  }

  cancelEdit() {
    this.editing = false;
    this.current = null;
    this.editIndex = -1;
    this.submitted = false;
  }

  done() {
    this.saved = true;
    this.modalInstance.remove();
  }

  closeWindow() {
    this.cancelled = true;
    this.modalInstance.remove();
  }

  normalizeFilms(films) {
    const value = parseInt(films, 10);

    if (isNaN(value) || value < MIN_FILMS) {
      return MIN_FILMS;
    }

    if (value > MAX_FILMS) {
      return MAX_FILMS;
    }

    return value;
  }

  projectionLabel(code) {
    const match = this.projections.find((p) => p.Key === code);
    return match ? match.Value : code;
  }

  reasonLabel(code) {
    const match = this.reasons.find((r) => r.Key === code);
    return match ? match.Value : code;
  }

  getSummary() {
    return this.records
      .map(
        (r) =>
          `${this.projectionLabel(r.Projection)} (${r.Films}) - ${this.reasonLabel(
            r.Reason
          )}`
      )
      .join("; ");
  }
}



// WEBPACK FOOTER //
// ./src/scripts/models/repeatFilmDialogModel.js